// src/pages/HomePage.tsx
import React from 'react';
import Services from '../../components/Body/Services';
import Navbar from '../../components/Header/Navbar';
import Footer from '../../components/Footer/Footer';
import Hero from '../../components/Body/Hero';
import GetInTouch from '../../components/Body/GetInTouch';
import HowItWorks from '../../components/Body/HowItWorks';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../i18n';



const HomePage: React.FC = () => {
  return (
     <I18nextProvider i18n={i18n}>
    <div>
      <Navbar />
      <Hero />
      <HowItWorks />
      <Services />
      <GetInTouch />
      <Footer />

    </div>
    </I18nextProvider>
  );
};

export default HomePage;